import { AfterContentInit, Component, OnInit } from '@angular/core';
import { NavigationService, NavigationServiceMenu } from '../../services/navigation.service';
import { NotificationService } from '../../services/notification.service';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-sidemenu',
    templateUrl: './app-sidemenu.component.html',
    styleUrls: ['./app-sidemenu.component.scss']
})
export class AppSidemenuComponent implements OnInit, AfterContentInit {
    protected subscriptions: Subscription[] = [];

    navigation: NavigationServiceMenu[] = [];
    currentNotificationsCount: number = 0;

    constructor(
        private navigationService: NavigationService,
        protected notificationService: NotificationService,
    ) { }

    ngOnInit(): void {
        this.navigation = this.navigationService.getNavigation();

        const notificationsCountSubscription = this.notificationService.getMessagesCount().subscribe(count => {
            this.currentNotificationsCount = count;
        });
        this.subscriptions.push(notificationsCountSubscription);
    }

    ngAfterContentInit(): void {
        setTimeout(() => {
            this.showTooltip();
        });
    }

    showTooltip() {
        let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));

        tooltipTriggerList.forEach(function (tooltipTriggerEl) {
            // @ts-ignore
            new bootstrap.Tooltip(tooltipTriggerEl);
        });
    }

    onNavItemEnter(event: Event, menuItem: HTMLElement): void {
        // @ts-ignore
        const tooltip = bootstrap.Tooltip.getInstance(menuItem);
        tooltip && tooltip?.show();
    }

    onNavItemLeave(event: Event, menuItem: HTMLElement): void {
        // @ts-ignore
        const tooltip = bootstrap.Tooltip.getInstance(menuItem);
        tooltip && tooltip?.hide();
    }

}
